/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'accounts';

export const userProfileModalBreadcrumbTitle = `${prefix}.userProfileModalBreadcrumbTitle`;

export const ENGLISH = {
    [userProfileModalBreadcrumbTitle]: 'User Profile',
};
